import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";

if (dbh_helper.getUrlArea() == "abrechnungen" && window.location.pathname.toLowerCase().indexOf("lauferstellen") > 0) {
    $(document).ready(function () {
        $("#btnLaufDurchfuehren").on("click", function () {
            const form = $("form");
            //const parameter = new dbh_ajax().getPostParameterStringForForm(form);
            const action = "LaufErstellen";
            const controller = window.location.pathname.toLowerCase().indexOf("gutschriften") > 0 ? "Gutschriften" : "Rechnungen";

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: action,
                controllerName: `Abrechnungen/${controller}`,
                parameter: dbh_helper.getParameterStringForForm(form),
                callbackSuccess: (ajaxResult: any) => {
                    $("#btnLaufDurchfuehren").css("display", "none");
                    $("#noPsgSpan").css("display", "none");
                    $("#textDone").css("display", "block");
                    $("#btnRechnungenSuchen").css("display", "flex");
                },
                callbackError: (ajaxResult: any) => {
                    if (ajaxResult.responseText && ajaxResult.responseText === "Pflegesatzgruppe") {
                        $("#noPsgSpan").css("display", "block");
                    }
                }
            });
        });
    });
}
